import type { LinkToLeadershipLiveSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-leadership-live';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LinkToLeadershipLive: TemplateOnlyComponent<LinkToLeadershipLiveSignature> =
  <template>
    <a href="#" ...attributes>{{yield}}</a>
  </template>;

export { LinkToLeadershipLive };
